var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "youtube",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.78,
    height: 27.852,
    viewBox: "0 0 39.78 27.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M38.961,4.358A4.984,4.984,0,0,0,35.455.852C32.342,0,19.89,0,19.89,0S7.438,0,4.325.819A5.086,5.086,0,0,0,.819,4.358C0,7.471,0,13.926,0,13.926s0,6.488.819,9.568A4.984,4.984,0,0,0,4.325,27c3.146.852,15.565.852,15.565.852s12.452,0,15.565-.819a4.984,4.984,0,0,0,3.506-3.506c.819-3.113.819-9.568.819-9.568s.033-6.488-.819-9.6Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M38.943,20.258,28.588,14.294V26.222Z",
    transform: "translate(-12.663 -6.332)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/you_Tube.6d8b0de83f8350c8cc0f84462b9c79b6.svg";
export { ForwardRef as ReactComponent };